import clsx from "clsx";
import { useEffect, useState } from "react";

import { Product } from "@transfr-inc/dashboard-components/constants";
import { Button } from "@transfr-inc/dashboard-components/forms";
import { ChartFilter } from "@components/custom/forms";
import { useDateStore } from "@src/stores/zustand/date-store";
import { DashboardChart } from "./dashboard.chart";
import { ProgramDataboxes } from "./program.databoxes";

import "./dashboard.insights.scss";

export function ProgramInsights({
  userInfo,
  orgCode,
  generalStats,
  dailyStats,
  onApplyFilters,
  classroomFilterEnabled,
  organizationFilterEnabled,
  className,
  programFilterEnabled,
  onExportData,
  exportDataDisabled,
  professionalLearning,
}) {
  const [categorySelected, setCategorySelected] = useState();
  const lastDateFilter = useDateStore((state) => state.lastDateFilter);
  const [dateFilter, setDateFilter] = useState(lastDateFilter);
  const [allTimeStartDate, setAllTimeStartDate] = useState();
  const [truncatedDailyStats, setTruncatedDailyStats] = useState(dailyStats);

  useEffect(() => {
    setTruncatedDailyStats(dailyStats);
    if (!dailyStats?.isLoading && dateFilter > 365 && dailyStats?.response) {
      let firstDataIndex = dailyStats.response.findIndex(
        (item) => Object.keys(item).length > 1
      );
      firstDataIndex = firstDataIndex == -1 ? 0 : firstDataIndex;
      const truncated = dailyStats?.response.slice(firstDataIndex);

      setTruncatedDailyStats({
        ...dailyStats,
        response: truncated,
      });
      setAllTimeStartDate(truncated[0].date);
    }
  }, [dailyStats, dateFilter]);

  const onToggleAllTime = (allTimeSelected) => {
    if (allTimeSelected) {
      setDateFilter(366);
    } else {
      setDateFilter();
      setAllTimeStartDate();
    }
  };

  return (
    <div className={clsx("dashboard-insights", className)}>
      <div className="subheader">
        <ChartFilter
          onApplyFilters={onApplyFilters}
          userInfo={userInfo}
          orgCode={orgCode}
          classroomEnabled={classroomFilterEnabled}
          organizationEnabled={organizationFilterEnabled}
          product={Product.PROG}
          loading={truncatedDailyStats?.isLoading}
          allTimeStartDate={allTimeStartDate}
          onToggleAllTime={onToggleAllTime}
          programEnabled={programFilterEnabled}
          professionalLearning={professionalLearning}
        />
        <div className="right-hand-buttons">
          <Button
            primary
            size="small"
            icon={["fa-light", "file-export"]}
            onClick={onExportData}
            disabled={exportDataDisabled}
          >
            Export Data
          </Button>
        </div>
      </div>
      <ProgramDataboxes
        onCategoryChange={setCategorySelected}
        data={generalStats}
      ></ProgramDataboxes>
      <DashboardChart
        className="chart"
        dailyStats={truncatedDailyStats}
        filterSelected={categorySelected}
      />
    </div>
  );
}
